
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { djangoApi } from "../api/auth";

export default function InstituteChangePassword() {
  const navigate = useNavigate();

  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError("");
    setSuccess("");

    if (newPassword !== confirmPassword) {
      setError("New password and confirmation do not match.");
      return;
    }

    setLoading(true);

    try {
      const response = await djangoApi.post(
        "/api/auth/institute/change-temporary-password/",
        {
          current_password: currentPassword,
          new_password: newPassword,
          confirm_password: confirmPassword,
        }
      );

      setSuccess(
        response.data?.detail ||
          "Password changed successfully. Please continue to your dashboard."
      );

      setCurrentPassword("");
      setNewPassword("");
      setConfirmPassword("");

      // Allow the success message to be read before navigating.
      setTimeout(() => navigate("/institute/dashboard", { replace: true }), 1200);
    } catch (err) {
      const detail = err.response?.data?.detail;
      setError(
        Array.isArray(detail)
          ? detail.join(" ")
          : detail || "Unable to change the password. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container min-vh-100 d-flex align-items-center justify-content-center py-4">
      <div className="card shadow-sm border-0 w-100" style={{ maxWidth: 480 }}>
        <div className="card-body p-4 p-md-5">
          <div className="text-center mb-4">
            <div className="mb-3 text-primary">
              <i className="bi bi-shield-lock" style={{ fontSize: 42 }} />
            </div>
            <h1 className="h4 fw-bold">Change Temporary Password</h1>
            <p className="text-muted small mb-0">
              Set a new password before continuing to your institute dashboard.
            </p>
          </div>

          {error && (
            <div className="alert alert-danger py-2 small" role="alert">
              {error}
            </div>
          )}

          {success && (
            <div className="alert alert-success py-2 small" role="status">
              {success}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label className="form-label">Current temporary password</label>
              <input
                type="password"
                className="form-control"
                autoComplete="current-password"
                value={currentPassword}
                onChange={(event) => setCurrentPassword(event.target.value)}
                required
              />
            </div>

            <div className="mb-3">
              <label className="form-label">New password</label>
              <input
                type="password"
                className="form-control"
                autoComplete="new-password"
                value={newPassword}
                onChange={(event) => setNewPassword(event.target.value)}
                required
              />
            </div>

            <div className="mb-4">
              <label className="form-label">Confirm new password</label>
              <input
                type="password"
                className="form-control"
                autoComplete="new-password"
                value={confirmPassword}
                onChange={(event) => setConfirmPassword(event.target.value)}
                required
              />
            </div>

            <button
              type="submit"
              className="btn btn-primary w-100"
              disabled={loading}
            >
              {loading ? "Changing password..." : "Change Password"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
